<div class="notice-container">
    <img src="/assets/tyt.svg">
    <span class="first">You're already logged in with a current membership.</span>
    <span class="second">To upgrade your membership or make a one-time donation, visit your Settings page.</span>
    <div class="button-container">
        <a routerLink="/settings/one-time-contribution" class="settings">Settings</a>
        <a href="{{appUrl}}" class="home">Home</a>
    </div>
</div>